import React from "react";
import { ODL_ICONS } from "@odl/core/components/DataDisplay/FontIcon";

export const useCollapse = (isCollapsedInitially: boolean) => {
  const [isCollapsed, setIsCollapsed] = React.useState(isCollapsedInitially);

  const collapse = React.useCallback(() => {
    setIsCollapsed(true);
  }, []);

  const expand = React.useCallback(() => {
    setIsCollapsed(false);
  }, []);

  const toggleCollapse = React.useCallback(() => {
    setIsCollapsed((prev) => !prev);
  }, [setIsCollapsed]);

  const chevronIcon = React.useMemo(() => {
    if (isCollapsed) {
      return "i-navigation-chevron-up";
    }
    return "i-navigation-chevron-down";
  }, [isCollapsed]);

  return {
    isCollapsed,
    toggleCollapse,
    expand,
    collapse,
    chevronIcon: chevronIcon as typeof ODL_ICONS[keyof typeof ODL_ICONS],
  };
};
